export default function LastComponent() {
  return (
    <div className="xs:p-2 bg-white absolute h-full bottom-[-2em] left-[.9em] z-[2]" />
  );
}
